import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import sl from '@/locales/sl'
import en from '@/locales/en'
import AButton from '@/components/AButton.vue'
import AInfoPanel from '@/components/AInfoPanel.vue'
import MainPageTitle from '@/blocks/mainPageTitle.vue'
import Card from '@/blocks/card.vue'
import Delimiter from '@/blocks/delimiter.vue'
import IconBack from '@/icons/IconBack.vue'
import App from '@/App.vue'
import router from '@/router'
import '@/styles/index.scss'

import urskaImage from '@/assets/urska.jpg'
import naslovna from '@/assets/covers/naslovna.jpg'
import naslovnaMobile from '@/assets/covers/naslovna-mobile.jpg'
import ACircularImage from '@/components/ACircularImage.vue'
import { initAnalytics } from '@/utils/analytics'
import vFlick from './blocks/v-flick'

function addPreloadLink(href: string) {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.as = 'image'
    link.href = href
    document.head.appendChild(link)
}

addPreloadLink(window.innerWidth < 640 ? naslovnaMobile : naslovna)

addPreloadLink(urskaImage)

const i18n = createI18n({
    legacy: false,
    locale: 'sl',
    fallbackLocale: 'sl',
    messages: { sl, en },
})

const app = createApp(App)

app.component('AButton', AButton)
app.component('ACircularImage', ACircularImage)
app.component('IconBack', IconBack)
app.component('MainPageTitle', MainPageTitle)
app.component('Card', Card)
app.component('Delimiter', Delimiter)
app.component('AInfoPanel', AInfoPanel)
app.directive('flick', vFlick)

router.beforeEach((to, _, next) => {
    const { t } = i18n.global

    // Set locale based on route meta
    const metaLocale = to.meta.locale as string | undefined
    i18n.global.locale.value = (metaLocale === 'en' ? 'en' : 'sl') as 'sl' | 'en'

    // Set the page title
    const titleKey = to.meta.titleKey as string | undefined
    const title = to.meta.title as string | undefined
    if (titleKey) {
        document.title = t(titleKey)
    } else if (title) {
        document.title = title
    }

    // Set the meta description
    const descriptionKey = to.meta.descriptionKey as string | undefined
    const description = descriptionKey ? t(descriptionKey) : (to.meta.description as string | undefined)
    if (description) {
        const metaDescription = document.querySelector('meta[name="description"]')
        if (metaDescription) {
            metaDescription.setAttribute('content', description)
        } else {
            const meta = document.createElement('meta')
            meta.name = 'description'
            meta.content = description
            document.head.appendChild(meta)
        }

        const ogDescription = document.querySelector('meta[property="og:description"]')
        if (ogDescription) {
            ogDescription.setAttribute('content', description)
        } else {
            const meta = document.createElement('meta')
            meta.setAttribute('property', 'og:description')
            meta.setAttribute('content', description)
            document.head.appendChild(meta)
        }
    }

    next()
})

initAnalytics(router, i18n)

app.use(router).use(i18n).mount('#app')
